import React, { FC } from 'react'
import block from 'bem-cn'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import './WeekItem.scss'

type Props = {
  weekNumber: number
}

const b = block('week-item')

const WeekItem: FC<Props> = ({ weekNumber }) => {
  const { tPrefix } = useAppTranslation('common')

  return <div className={b()}>{tPrefix(`week.day.short.${weekNumber}`)}</div>
}

export { WeekItem }
